// Language context and types
export interface Language {
  code: 'en' | 'ar';
  name: string;
  direction: 'ltr' | 'rtl';
}

export const languages: Language[] = [
  { code: 'en', name: 'English', direction: 'ltr' },
  { code: 'ar', name: 'العربية', direction: 'rtl' }
];

// Translation interface
export interface Translations {
  // Navigation
  home: string;
  products: string;
  health: string;
  beauty: string;
  contact: string;
  policies: string;
  
  // Homepage
  featuredProducts: string;
  aboutMission: string;
  ourPartners: string;
  services: string;
  contactUs: string;
  requestCallback: string;
  companyMission: string;
  missionText: string;
  
  // Products
  productDetails: string;
  viewDetails: string;
  allCategories: string;
  subcategories: string;
  
  // Health subcategories
  supplements: string;
  vitamins: string;
  digestiveHealth: string;
  
  // Beauty subcategories
  skincare: string;
  antiAging: string;
  cleansers: string;
  sunProtection: string;
  
  // Contact
  name: string;
  email: string;
  phone: string;
  message: string;
  submit: string;
  contactForm: string;
  
  // Policies
  privacyPolicy: string;
  termsOfService: string;
  
  // Common
  loading: string;
  readMore: string;
  backToProducts: string;
}

export const translations: Record<string, Translations> = {
  en: {
    // Navigation
    home: 'Home',
    products: 'Products',
    health: 'Health',
    beauty: 'Beauty',
    contact: 'Contact',
    policies: 'Policies',
    
    // Homepage
    featuredProducts: 'Featured Products',
    aboutMission: 'About & Mission',
    ourPartners: 'Our Partners',
    services: 'Our Services',
    contactUs: 'Contact Us',
    requestCallback: 'Request Callback',
    companyMission: 'Unicare Pharma Mission',
    missionText: 'We are committed to providing high-quality pharmaceutical and beauty products to improve the health and well-being of our community. Our mission is to make healthcare accessible and affordable for everyone.',
    
    // Products
    productDetails: 'Product Details',
    viewDetails: 'View More',
    allCategories: 'All Categories',
    subcategories: 'Subcategories',
    
    // Health subcategories
    supplements: 'Supplements',
    vitamins: 'Vitamins',
    digestiveHealth: 'Digestive Health',
    
    // Beauty subcategories
    skincare: 'Skincare',
    antiAging: 'Anti-Aging',
    cleansers: 'Cleansers',
    sunProtection: 'Sun Protection',
    
    // Contact
    name: 'Name',
    email: 'Email',
    phone: 'Phone Number',
    message: 'Message',
    submit: 'Submit',
    contactForm: 'Contact Form',
    
    // Policies
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    
    // Common
    loading: 'Loading...',
    readMore: 'Read More',
    backToProducts: 'Back to Products'
  },
  ar: {
    // Navigation
    home: 'الرئيسية',
    products: 'المنتجات',
    health: 'الصحة',
    beauty: 'الجمال',
    contact: 'اتصل بنا',
    policies: 'السياسات',
    
    // Homepage
    featuredProducts: 'المنتجات المميزة',
    aboutMission: 'حول الشركة والرسالة',
    ourPartners: 'شركاؤنا',
    services: 'خدماتنا',
    contactUs: 'اتصل بنا',
    requestCallback: 'طلب اتصال',
    companyMission: 'رسالة يونيكير فارما',
    missionText: 'نحن ملتزمون بتوفير منتجات صيدلانية وتجميلية عالية الجودة لتحسين صحة ورفاهية مجتمعنا. رسالتنا هي جعل الرعاية الصحية متاحة وبأسعار معقولة للجميع.',
    
    // Products
    productDetails: 'تفاصيل المنتج',
    viewDetails: 'عرض المزيد',
    allCategories: 'جميع الفئات',
    subcategories: 'الفئات الفرعية',
    
    // Health subcategories
    supplements: 'المكملات الغذائية',
    vitamins: 'الفيتامينات',
    digestiveHealth: 'صحة الجهاز الهضمي',
    
    // Beauty subcategories
    skincare: 'العناية بالبشرة',
    antiAging: 'مضادات الشيخوخة',
    cleansers: 'المنظفات',
    sunProtection: 'الحماية من الشمس',
    
    // Contact
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    message: 'الرسالة',
    submit: 'إرسال',
    contactForm: 'نموذج الاتصال',
    
    // Policies
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',
    
    // Common
    loading: 'جاري التحميل...',
    readMore: 'اقرأ المزيد',
    backToProducts: 'العودة للمنتجات'
  }
};